import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Panel, Kpi } from "./OfficeLayout";
import { PerfTable } from "./Dashboard";
import { PartnerLeadTable } from "./Leads";
import { QrAsset } from "../../components/office/QrAsset";
import { api, titleize } from "../../lib/api";

export default function PartnerDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/office/partner/me").then(({ data }) => setD(data)); }, []);
  if (!d) return <Loader2 className="h-6 w-6 animate-spin text-primary" />;
  const m = d.metrics;
  const kpis = [["Total QR scans", m.scans], ["Total link clicks", m.clicks], ["Total leads", m.intakes_started], ["Intakes started", m.intakes_started],
    ["Intakes completed", m.intakes_completed], ["Specialist referrals", m.handoffs], ["Active cases", m.active_cases], ["Closed cases", m.closed], ["Conversions", m.conversions]];
  return (
    <div className="space-y-4" data-testid="partner-dashboard">
      <div><p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{titleize(d.partner.type)} • {d.partner.id}</p><h1 className="text-2xl font-bold">{d.partner.name}</h1></div>
      <div className="grid gap-4 xl:grid-cols-[1.2fr_1fr]">
        <Panel title="My referral link & QR code">{d.master_link && <QrAsset link={d.master_link} />}</Panel>
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-2">{kpis.map(([l, v]) => <Kpi key={l} l={l} v={v} testId={`pkpi-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`} />)}</div>
          <Panel title="Compensation status (where legally permissible)" testId="partner-compensation">
            {Object.entries(d.compensation).map(([k, v]) => <p key={k} className="flex justify-between text-xs"><span>{titleize(k)}</span><span className="font-mono">{v}</span></p>)}
            <p className="mt-2 text-[11px] text-muted-foreground">Compensation is reviewed for compliance before any approval. Homeowner identity, financials and documents are not shared with partners.</p>
          </Panel>
        </div>
      </div>
      <Panel title="Campaign performance"><PerfTable rows={d.campaigns} testId="partner-campaigns" /></Panel>
      <Panel title="My referred leads (status only)"><PartnerLeadTable leads={d.leads} /></Panel>
    </div>
  );
}
